/* TANVI fragrance guide (sections/tanvi-fragrance.liquid). Added 2026-09-29.
   1) page background glides between the scent colours while scrolling
   2) the story-by-time graph draws itself when they come into view */
(function () {
function init(root) { /* 2026-09-30: one init per root (guide page, product-page module, product-page mini chart) */
  if (!root || root.getAttribute('data-tfr-ready')) return;
  root.setAttribute('data-tfr-ready', '1');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scents = Array.prototype.slice.call(root.querySelectorAll('[data-tanvi-scent]'));

  /* ---------- background ---------- */
  function rgb(hex) {
    var h = String(hex || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (h.length !== 6 || isNaN(n)) return [21, 21, 21];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function ease(t) { return t * t * t * (t * (t * 6 - 15) + 10); } // smootherstep: no visible start or stop
  var stops = [rgb(root.getAttribute('data-base'))].concat(scents.map(function (s) { return rgb(s.getAttribute('data-bg')); }));
  var current = null, ticking = false;
  var photos = Array.prototype.slice.call(root.querySelectorAll('.tanvi-fr__photo')), photoState = [];

  function paint() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // each scent takes over while its top edge travels from 85% to 30% of the screen height
    var from = vh * 0.85, to = vh * 0.3;
    var c = stops[0];
    for (var i = 0; i < scents.length; i++) {
      var top = scents[i].getBoundingClientRect().top;
      var t = (from - top) / (from - to);
      if (t <= 0) break;
      t = ease(Math.min(1, t));
      var a = c, b = stops[i + 1];
      c = [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
    }
    // photos: monochrome at the edges of the screen, colour while they pass the middle
    for (var k = 0; k < photos.length; k++) {
      var r = photos[k].getBoundingClientRect();
      var amount = 0;
      if (r.bottom > 0 && r.top < vh && !reduce) {
        var d = Math.abs((r.top + r.height / 2) - vh * 0.45) / vh;
        amount = 1 - ease(Math.max(0, Math.min(1, (d - 0.1) / 0.4)));
      }
      amount = Math.round(amount * 100) / 100;
      if (photoState[k] !== amount) { photoState[k] = amount; photos[k].style.setProperty('--tfr-color', amount); }
    }
    var css = 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')';
    if (css !== current) { current = css; root.style.backgroundColor = css; }
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(paint); } }

  if (scents.length) {
    root.classList.add('is-live');
    paint();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('load', request);
  }

  /* ---------- graph ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  // smooth path through points (Catmull-Rom -> cubic Bezier), kept inside the plot
  function path(pts, floor) {
    var d = 'M' + pts[0][0] + ',' + pts[0][1];
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      var c1 = [p1[0] + (p2[0] - p0[0]) / 6, Math.min(floor, p1[1] + (p2[1] - p0[1]) / 6)];
      var c2 = [p2[0] - (p3[0] - p1[0]) / 6, Math.min(floor, p2[1] - (p3[1] - p1[1]) / 6)];
      d += 'C' + c1[0].toFixed(1) + ',' + c1[1].toFixed(1) + ' ' + c2[0].toFixed(1) + ',' + c2[1].toFixed(1) + ' ' + p2[0].toFixed(1) + ',' + p2[1].toFixed(1);
    }
    return d;
  }
  // how each layer of a fragrance behaves over its life (0..1 of the duration), scaled by its strength
  var SHAPES = {
    top:    [1.00, 0.86, 0.52, 0.24, 0.09, 0.03, 0.00],
    middle: [0.30, 0.74, 1.00, 0.88, 0.58, 0.30, 0.12],
    base:   [0.10, 0.26, 0.52, 0.80, 1.00, 0.92, 0.70]
  };
  function draw(box) {
    var W = 520, H = 250, L = 46, R = 12, T = 14, B = 34;
    var dur = parseFloat(box.getAttribute('data-duration')) || 6;
    var view = '0 0 ' + W + ' ' + H;
    var svg = el('svg', { viewBox: view, role: 'img', 'aria-label': 'Top / Middle / Base, 0-' + dur + 'h' }, box);
    var pw = W - L - R, ph = H - T - B, floor = T + ph;
    for (var g = 1; g <= 3; g++) el('line', { 'class': 'tfr-grid', x1: L, x2: W - R, y1: T + ph * (g / 4), y2: T + ph * (g / 4) }, svg);
    el('path', { 'class': 'tfr-axis', d: 'M' + L + ',' + T + 'V' + floor + 'H' + (W - R) }, svg);
    var mid = T + ph / 2;
    var st = el('text', { 'class': 'tfr-strength', x: L - 20, y: mid, 'text-anchor': 'middle', transform: 'rotate(-90 ' + (L - 20) + ' ' + mid + ')' }, svg);
    st.textContent = 'Strength';
    var step = dur > 8 ? 2 : 1;
    for (var h = 0; h <= dur; h += step) {
      var x = L + pw * (h / dur);
      el('line', { 'class': 'tfr-axis', x1: x, x2: x, y1: floor, y2: floor + 4 }, svg);
      var tx = el('text', { x: x, y: floor + 20, 'text-anchor': 'middle' }, svg); tx.textContent = h + 'h';
    }
    var layer = document.createElement('div');
    layer.className = 'tfr-curves';
    box.appendChild(layer);
    var curves = el('svg', { viewBox: view, 'aria-hidden': 'true' }, layer);
    ['base', 'middle', 'top'].forEach(function (key) {
      var level = Math.max(1, Math.min(10, parseFloat(box.getAttribute('data-' + key)) || 7));
      var values = SHAPES[key].map(function (v) { return v * level; });
      // a scent can describe its own curve: values from start to end, 0-10
      var own = (box.getAttribute('data-curve-' + key) || '').split(',').map(function (v) { return parseFloat(v); }).filter(function (v) { return !isNaN(v); });
      if (own.length >= 3) values = own.map(function (v) { return Math.max(0, Math.min(10, v)); });
      var pts = values.map(function (v, i, arr) {
        return [L + pw * (i / (arr.length - 1)), floor - 3 - (ph - 3) * (v / 10.5)];
      });
      var d = path(pts, floor - 3);
      if (key === 'base') { // double line: the same curve drawn twice, a hair apart
        el('path', { 'class': 'tfr-line tfr-base', d: d, transform: 'translate(0,-1.7)' }, curves);
        el('path', { 'class': 'tfr-line tfr-base', d: d, transform: 'translate(0,1.7)' }, curves);
      } else {
        el('path', { 'class': 'tfr-line tfr-' + key, d: d }, curves);
      }
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-tfr-chart]'), draw);

  /* ---------- Japanese phrase-aware line breaks (same approach as the ABOUT page; needs assets/budoux-ja.min.js) ---------- */
  function phrase() {
    if (!window.customElements || !customElements.get('budoux-ja')) return;
    var els = root.querySelectorAll('h1[data-tfr-phrase], [data-tfr-phrase] p');
    Array.prototype.forEach.call(els, function (n) {
      if (n.getAttribute('data-phrase-wrap')) return;
      n.setAttribute('data-phrase-wrap', '1');
      var b = document.createElement('budoux-ja');
      while (n.firstChild) b.appendChild(n.firstChild);
      n.appendChild(b);                       // connectedCallback inserts the phrase breaks synchronously
      while (b.firstChild) n.insertBefore(b.firstChild, b);
      n.removeChild(b);
      n.normalize();
      var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT, null, false), t, list = [];
      while ((t = w.nextNode())) list.push(t);
      list.forEach(function (x) { var v = x.nodeValue.split('作り\u200bあげ').join('作りあげ').split('香の\u200b世界').join('香の世界'); if (v !== x.nodeValue) x.nodeValue = v; });
      n.style.wordBreak = 'keep-all';
      n.style.overflowWrap = 'anywhere';
    });
  }
  phrase();
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('budoux-ja').then(phrase); // the library may finish loading after this script

  /* ---------- products accordion ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-tfr-acc]'), function (box) {
    var btn = box.querySelector('.tanvi-fr__acc');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) window.dispatchEvent(new Event('resize')); // lets the theme's lazy images / grid measure the now visible cards
    });
  });

  /* ---------- reveal on view ---------- */
  function show(n) {
    n.classList.add('is-in');
  }
  var targets = Array.prototype.slice.call(root.querySelectorAll('[data-tfr-reveal], [data-tfr-chart]'));
  function markCurrent(n) { n.classList.add('is-current'); }
  if (reduce || !('IntersectionObserver' in window)) {
    scents.forEach(markCurrent);
  } else {
    var ioScent = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { markCurrent(e.target); ioScent.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -25% 0px' });
    scents.forEach(function (n) { ioScent.observe(n); });
  }
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(show);
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (n) { io.observe(n); });
  }
}
Array.prototype.forEach.call(document.querySelectorAll('[data-tanvi-fragrance]'), init);
})();
